<template>
    <basic-content-layout id="subscription-information-page" class="h-100">
        <catalog-page-header class="mb-5"></catalog-page-header>

        <div id="content-area">
            <b-container
                class="mb-5"
                v-if="!isLoading && !error"
            >
                <h1 class="display-2" v-html="pageTitle"></h1>
                <b-row>
                    <b-col class="mb-3">
                        <span v-html="pageContent"></span>
                    </b-col>
                </b-row>
            </b-container>

            <b-container
                class="mb-5"
                v-if="isLoading"
            >
                <b-skeleton  width="40%" height="4.209rem" class="mb-5"></b-skeleton>
                <b-row>
                    <b-col class="mb-3">
                        <b-skeleton width="60%" height="1rem"></b-skeleton>
                        <b-skeleton width="36%" height="1rem"></b-skeleton>
                        <b-skeleton width="45%" height="1rem"></b-skeleton>
                        <b-skeleton width="55%" height="1rem"></b-skeleton>
                    </b-col>
                </b-row>
            </b-container>


            <b-container
                class="mb-5"
                v-if="!isLoading && error"
            >
                <error404></error404>
            </b-container>
        </div>
    </basic-content-layout>
</template>
<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import CatalogPageHeader from "../../components/organisms/CatalogPageHeader.vue";
import Error404 from "../../components/organisms/Error404.vue";
import { BContainer, BRow, BCol, BSkeleton } from "bootstrap-vue";

export default {
    components: {
        BasicContentLayout,
        CatalogPageHeader,
        BContainer, BRow, BCol,
        BSkeleton,
        Error404
    },
    data() {
        return {
            data: '',
            isLoading: true,
            error: false,
            title: '',
            content: '',
            meta_description: '',
        }
    },
    methods: {
        getContent(){
            this.error = false
            this.isLoading = true
            const language = this.$i18n.locale.startsWith('de-DE') ? 'de_DE' : this.$i18n.locale.substring(0, 2);

            let path = this.$route.path.split("/").join("");
            this.$axios.post('api/v1/content/get_page', {
                slug: path,
                language: language
            })
                .then(response => {
                    this.isLoading = false
                    this.data = response.data.payload.data
                    this.content = this.data.content;
                    if (this.data.meta_description !== undefined) {
                        this.meta_description = this.data.meta_description;
                    }
                })
                .catch(error => {
                    this.error = true
                    this.title = '404 not found'
                    this.$emit('updateHead')
                });
        },
        removeOldMetaDescription() {
            const el = document.querySelector("[name='description']");
            if (el !== null) {
                el.remove();
            }
        }
    },
    mounted() {
        this.getContent()
    },
    watch: {
        '$route.params.path'() {
            this.getContent();
        },
        data(){
            if(this.data !== null){
                this.title = this.data.title
                this.$emit('updateHead')
            }
        }
    },
    computed: {
        pageContent(){
            return this.data ? JSON.parse(this.content).legal_text : ''
        },
        pageTitle(){
            return this.data ? this.data.title : ''
        },
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.title
            }
        },
        meta: function () {

            // remove existing meta
            this.removeOldMetaDescription();

            if (this.meta_description !== null) {
                return [
                    { name: 'description', content: this.meta_description },
                ]
            }
        }
    }
}
</script>
